<div *transloco="let t; read: 'color-palette-import'" class="xi-modal__container">
  <h2 class="xi-modal__title kxi-text-center">{{ t('title') }}</h2>

  <div class="xi-modal__content">
    <xi-text-area
      [placeholder]="t('palette-placeholder')"
      [label]="t('paste-palette')"
      [(ngModel)]="colorPaletteString"
      name="paste-palette"
      [height]="100"
      [status]="colorPaletteStatus"
      (onChange)="onValidateColorPalette()"
    ></xi-text-area>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      type="button"
      [text]="t('cancel')"
      fill="text"
      (onClick)="onCancel()"
    ></xi-default-button>

    <xi-default-button
      [text]="t('import')"
      [disabled]="!colorPalette?.length"
      (onClick)="onImport()"
    ></xi-default-button>
  </div>
</div>
